import styled from 'styled-components';

export const BankAccount = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 200px;
  gap: 0 10px;
`;
